export const perfil = {
  salarioPretendido: {
    empty: 'No encontramos postulaciones con tu pretensión salarial',
  },
}
